import axios from "axios";
import { urlBase } from "../../Constante/Url";
import { UserTockem } from "../../Utils/autenticacao";

const getConfig = (params = {}, extraHeaders = {}) => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem(UserTockem)}`,
    ...extraHeaders,
  },
  params,
});

const getPaginated = (path, page, pageSize, params = {}) => {
  const offset = (page - 1) * pageSize;
  return axios.get(`${urlBase}${path}?limit=${pageSize}&offset=${offset}`, {
    ...getConfig(params),
  });
};

const getList = (path, params = {}) => {
  return axios.get(`${urlBase}${path}`, getConfig(params));
};

const getById = (path, id) => {
  return axios.get(`${urlBase}${path}${id}/`, getConfig());
};

const remove = (path, id) => {
  return axios.delete(`${urlBase}${path}${id}/`, getConfig());
};

const saveJson = (path, data, id) => {
  if (id) {
    return axios.patch(`${urlBase}${path}${id}/`, data, getConfig());
  }

  return axios.post(`${urlBase}${path}`, data, getConfig());
};

const saveMultipart = (path, data, id) => {
  const config = getConfig({}, { "Content-Type": "multipart/form-data" });

  if (id) {
    return axios.patch(`${urlBase}${path}${id}/`, data, config);
  }

  return axios.post(`${urlBase}${path}`, data, config);
};

const getCategorias = (page, pageSize, params) =>
  getPaginated("implantacao/categoria/", page, pageSize, params);
const saveCategoria = (data, id) =>
  saveJson("implantacao/categoria/", data, id);
const deleteCategoria = (id) => remove("implantacao/categoria/", id);

const getFases = (page, pageSize, params) =>
  getPaginated("implantacao/fase/", page, pageSize, params);
const saveFase = (data, id) => saveJson("implantacao/fase/", data, id);
const deleteFase = (id) => remove("implantacao/fase/", id);

const getItensChecklist = (page, pageSize, params) =>
  getPaginated("implantacao/item-checklist/", page, pageSize, params);
const saveItemChecklist = (data, id) =>
  saveJson("implantacao/item-checklist/", data, id);
const deleteItemChecklist = (id) => remove("implantacao/item-checklist/", id);

const getImplantacoes = (page, pageSize, params) =>
  getPaginated("implantacao/controle/", page, pageSize, params);
const getImplantacao = (id) => getById("implantacao/controle/", id);
const saveImplantacao = (data, id) =>
  saveJson("implantacao/controle/", data, id);
const deleteImplantacao = (id) => remove("implantacao/controle/", id);
const criarFasesPadrao = (id) =>
  axios.post(
    `${urlBase}implantacao/controle/${id}/criar-fases-padrao/`,
    {},
    getConfig()
  );
const getRelatorioImplantacao = (id) =>
  axios.get(`${urlBase}implantacao/controle/${id}/relatorio/`, getConfig());
const getFluxoImplantacao = (id) =>
  axios.get(`${urlBase}implantacao/controle/${id}/fluxo/`, getConfig());
const iniciarImplantacaoReal = (id) =>
  axios.post(
    `${urlBase}implantacao/controle/${id}/iniciar-implantacao-real/`,
    {},
    getConfig()
  );

const getControleFases = (page, pageSize, params) =>
  getPaginated("implantacao/controle-fase/", page, pageSize, params);
const saveControleFase = (data, id) =>
  saveJson("implantacao/controle-fase/", data, id);
const deleteControleFase = (id) => remove("implantacao/controle-fase/", id);
const getControleFaseChecklist = (id) =>
  axios.get(`${urlBase}implantacao/controle-fase/${id}/checklist/`, getConfig());
const selecionarChecklistControleFase = (data) =>
  axios.post(
    `${urlBase}implantacao/controle-fase/checklist/selecionar/`,
    data,
    getConfig()
  );
const removerChecklistControleFase = (data) =>
  axios.post(
    `${urlBase}implantacao/controle-fase/checklist/remover/`,
    data,
    getConfig()
  );

const getRespostasChecklist = (page, pageSize, params) =>
  getPaginated("implantacao/resposta-checklist/", page, pageSize, params);
const saveRespostaChecklist = (data, id) =>
  saveJson("implantacao/resposta-checklist/", data, id);
const deleteRespostaChecklist = (id) =>
  remove("implantacao/resposta-checklist/", id);

const getEvidencias = (page, pageSize, params) =>
  getPaginated("implantacao/evidencia/", page, pageSize, params);
const saveEvidencia = (formData, id) =>
  saveMultipart("implantacao/evidencia/", formData, id);
const deleteEvidencia = (id) => remove("implantacao/evidencia/", id);

const getValidacoes = (page, pageSize, params) =>
  getPaginated("implantacao/validacao/", page, pageSize, params);
const saveValidacao = (data, id) =>
  saveJson("implantacao/validacao/", data, id);
const deleteValidacao = (id) => remove("implantacao/validacao/", id);

const getHistorico = (page, pageSize, params) =>
  getPaginated("implantacao/historico/", page, pageSize, params);

const getSistemas = (params = {}) => getList("sistema/", params);
const getCartorios = (params = {}) => getList("cartorio/", params);
const getUsuarios = (params = {}) => getList("usuario/registro/", params);

export const implantacaoRequest = {
  criarFasesPadrao,
  deleteCategoria,
  deleteControleFase,
  deleteEvidencia,
  deleteFase,
  deleteImplantacao,
  deleteItemChecklist,
  deleteRespostaChecklist,
  deleteValidacao,
  getCartorios,
  getCategorias,
  getControleFases,
  getControleFaseChecklist,
  getEvidencias,
  getFases,
  getFluxoImplantacao,
  getHistorico,
  getImplantacao,
  getImplantacoes,
  getItensChecklist,
  getRelatorioImplantacao,
  getRespostasChecklist,
  getSistemas,
  getUsuarios,
  getValidacoes,
  saveCategoria,
  saveControleFase,
  saveEvidencia,
  saveFase,
  saveImplantacao,
  saveItemChecklist,
  selecionarChecklistControleFase,
  removerChecklistControleFase,
  saveRespostaChecklist,
  saveValidacao,
  iniciarImplantacaoReal,
};

